<!-- Segmento da barra `stacked`: sem texto visível dentro (largura variável demais
     para garantir contraste legível em qualquer paleta/tema); a informação
     textual é carregada por title/aria-label e pela legenda sempre visível
     abaixo da barra. -->
@if (!slices().length) {
  <p class="distribution-bar__empty">Sem dados para exibir.</p>
} @else if (mode() === 'stacked') {
  <div class="distribution-bar">
    <div class="distribution-bar__track">
      @for (item of stackedItems(); track item.slice.key) {
        @if (item.widthPercent > 0) {
          @if (item.clickable) {
            <button
              type="button"
              class="distribution-bar__segment"
              [style.width.%]="item.widthPercent"
              [style.background-color]="item.color"
              [title]="item.accessibleLabel"
              [attr.aria-label]="item.accessibleLabel"
              (click)="onActivate(item)"></button>
          } @else {
            <div
              class="distribution-bar__segment distribution-bar__segment--static"
              [style.width.%]="item.widthPercent"
              [style.background-color]="item.color"
              [title]="item.accessibleLabel"></div>
          }
        }
      }
    </div>
    <ul class="distribution-bar__legend">
      @for (item of stackedItems(); track item.slice.key) {
        <li class="distribution-bar__legend-item">
          <span
            class="distribution-bar__legend-swatch"
            [style.background-color]="item.color"
            aria-hidden="true"></span>
          <span class="distribution-bar__legend-label">{{ item.slice.label }}</span>
          <span class="distribution-bar__legend-value">{{ item.displayValue }}</span>
        </li>
      }
    </ul>
  </div>
} @else {
  <ul class="distribution-bar distribution-bar--rows">
    @for (item of rowItems(); track item.slice.key) {
      <li class="distribution-bar__row">
        @if (item.clickable) {
          <button
            type="button"
            class="distribution-bar__row-button"
            [title]="item.accessibleLabel"
            (click)="onActivate(item)">
            <span class="distribution-bar__row-label">{{ item.slice.label }}</span>
            <span class="distribution-bar__row-track" aria-hidden="true">
              <span
                class="distribution-bar__row-fill"
                [style.width.%]="item.widthPercent"
                [style.min-width.px]="item.slice.count > 0 ? 2 : 0"
                [style.background-color]="item.color"></span>
            </span>
            <span class="distribution-bar__row-value">{{ item.displayValue }}</span>
          </button>
        } @else {
          <div class="distribution-bar__row-button distribution-bar__row-button--static">
            <span class="distribution-bar__row-label">{{ item.slice.label }}</span>
            <span class="distribution-bar__row-track" aria-hidden="true">
              <span
                class="distribution-bar__row-fill"
                [style.width.%]="item.widthPercent"
                [style.min-width.px]="item.slice.count > 0 ? 2 : 0"
                [style.background-color]="item.color"></span>
            </span>
            <span class="distribution-bar__row-value">{{ item.displayValue }}</span>
          </div>
        }
      </li>
    }
  </ul>
}
